import apiDashboard from '../../../api/dashboard';
import apiOption from '@/api/option'

const defaultState = () => ({
	listStatusSales: [],
	listTotalSales: [],
	listTotalPurchase: [],
	listResumeStock: [],
	listSalesProductWeekly: {day_arr: {}, results: []},
	listSalesPriceWeekly: {day_arr: [], results: []},
	listSalesRetailPriceWeekly: {day_arr: [], results: []},
	listSalesRetailWeekly: {day_arr: {}, results: []},
	listSalesProduct: [],
	listTopProduct: [],
	listWarehouse: [],
	listProduct: [],
});

const state = defaultState();

const getters = {

};

const mutations = {

	setListWarehouse(state, data) {
		state.listWarehouse = data
	},
	setListProduct(state, data) {
		state.listProduct = data
	},
	setStatusSales(state, data) {
		state.listStatusSales = data.data;
	},
	setTotalSales(state, data) {
		state.listTotalSales = data.data;
	},
	setTotalPurchase(state, data) {
		state.listTotalPurchase = data.data;
	},
	setResumeStock(state, data) {
		state.listResumeStock = data.data;
	},
	setSalesProduct(state, data) {
		state.listSalesProduct = data.data;
	},
	setSalesProductWeekly(state, data) {
		state.listSalesProductWeekly = {day_arr: data.day_arr, results: data.results};
	},
	setSalesRetailWeekly(state, data) {
		state.listSalesRetailWeekly = {day_arr: data.day_arr, results: data.results};
	},
	setSalesPriceWeekly(state, data) {
		let res = {day_arr: Object.keys(data), results: Object.values(data)};
		state.listSalesPriceWeekly = res;
	},
	setSalesRetailPriceWeekly(state, data) {
		let res = {day_arr: Object.keys(data), results: Object.values(data)};
		state.listSalesRetailPriceWeekly = res;
	},
	setTopProduct(state, data) {
		state.listTopProduct = data.data;
	},
};

const actions = {
	getOptionProductMain({ commit }) {
		return new Promise((resolve) => {
			apiOption.getOptionProductMain().then(({ data: { data } }) => {
				commit('setListProduct', data.results);
				resolve(data.results)
			}).catch(() => {
				commit('setListProduct', { data: [] });
			});
		});
	},
	getOptionWarehouseAll({ commit }) {
		return new Promise((resolve) => {
			apiOption.getOptionWarehouseAll().then(({ data: { data } }) => {
				commit('setListWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('setListWarehouse', { data: [] });
			});
		});
	},
	getStatusSales({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getStatusSales(params).then(({ data: { data } }) => {
				commit('setStatusSales', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setStatusSales', { data: [] });
			});
		});
	},
	getTotalSales({ commit }, params) {
		apiDashboard.getTotalSales(params).then(({ data: { data } }) => {
			commit('setTotalSales', { data: data.results });
		}).catch(() => {
			commit('setTotalSales', { data: [] });
		});
	},
	getTotalPurchase({ commit }, params) {
		apiDashboard.getTotalPurchase(params).then(({ data: { data } }) => {
			commit('setTotalPurchase', { data: data.results });
		}).catch(() => {
			commit('setTotalPurchase', { data: [] });
		});
	},
	getResumeStock({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getResumeStock(params).then(({ data: { data } }) => {
				commit('setResumeStock', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setResumeStock', { data: [] });
			});
		});
	},
	getSalesProduct({ commit }, params) {
		apiDashboard.getSalesProduct(params).then(({ data: { data } }) => {
			commit('setSalesProduct', { data: data.results });
		}).catch(() => {
			commit('setSalesProduct', { data: [] });
		});
	},
	getSalesProductWeekly({ commit }, params) {
		apiDashboard.getSalesProductWeekly(params).then(({ data: { data } }) => {
			commit('setSalesProductWeekly', data);
		}).catch(() => {
			commit('setSalesProductWeekly', {day_arr: {}, results: []});
		});
	},
	getSalesPriceWeekly({ commit }, params) {
		apiDashboard.getSalesPriceWeekly(params).then(({ data: { data } }) => {
			commit('setSalesPriceWeekly', data.results);
		}).catch(() => {
			commit('setSalesPriceWeekly', {});
		});
	},
	getSalesRetailWeekly({ commit }, params) {
		apiDashboard.getSalesRetailWeekly(params).then(({ data: { data } }) => {
			commit('setSalesRetailWeekly', data);
		}).catch(() => {
			commit('setSalesRetailWeekly', {});
		});
	},
	getSalesRetailPriceWeekly({ commit }, params) {
		apiDashboard.getSalesRetailPriceWeekly(params).then(({ data: { data } }) => {
			commit('setSalesRetailPriceWeekly', data.results);
		}).catch(() => {
			commit('setSalesRetailPriceWeekly', {});
		});
	},
	getTopProduct({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getTopProduct(params).then(({ data: { data } }) => {
				commit('setTopProduct', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setTopProduct', { data: [] });
			});
		});
	},
	// list({ commit, dispatch }) {
	// 	dashboardApi.getTransaction().then(({ data: { data } }) => {
	// 		if (data.results.length == 0) {
	// 			commit('listTransaction', { data: 'error', pagination: data.pagination });
	// 		} else {
	// 			commit('listTransaction', { data: data.results, pagination: data.pagination });
	// 		}
	// 	}).catch((err) => {
	// 		const { data } = err.response;
	// 		dispatch('errorHandler', data);
	// 	});
	// },
	// filter({ commit }, params) {
	// 	let parameterObject = {}
	// 	let parameter = '{'
	// 	params.forEach((value, index) => {
	// 		for (const [key, val] of Object.entries(value)) {
	// 			parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
	// 		}
	// 	})
	// 	parameter = parameter.slice(0, -1)
	// 	parameter += '}'
	// 	parameterObject = JSON.parse(parameter)
	// 	dashboardApi.getTransaction(parameterObject).then(({ data: { data } }) => {
	// 		if (data.results.length == 0) {
	// 			commit('listTransaction', { data: 'error', pagination: data.pagination });
	// 		} else {
	// 			commit('listTransaction', { data: data.results, pagination: data.pagination });
	// 		}
	// 	})
	// },
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};